/**
 * Theme exports
 * Centralized export point for theme-related utilities
 */

export * from './colors';
export * from './spacing';
export { hhglobalTheme } from './theme';
export * from './typography';
export { useTheme } from './useTheme';
export type { Theme } from '@mui/material/styles';

// Re-export for convenience
export { colorPurpose } from './colors';
export { spacingConfig } from './spacing';
export { typography } from './typography';

// Import and re-export default theme
import theme from './theme';
export default theme;
